import { MediaPlatformSettingsTabs } from './components/MediaPlatformSettingsTabs';

export const MediaPlatformSettingsForm = ({ isEdit = false }) => {
  return <MediaPlatformSettingsTabs isEdit={isEdit} />;
};
